import { Pagination } from '@/@types/member';

export function createTableOnlyPagination(): Pagination {
  return {
    descending: false,
    page: 1,
    rowsPerPage: 10,
    sortBy: null,
    totalItems: 0,
  };
}
